Shopware.Component.register('riccardo-age-check-list', () => import('./page/riccardo-age-check-list'));

Shopware.Module.register('riccardo-age-check', {
    type: 'plugin',
    name: 'riccardo-age-check',
    title: 'Altersprüfungen',
    description: 'Riccardo Altersprüfung',
    color: '#E30613',
    icon: 'regular-shield',
    entity: 'riccardo_age_verification',

    routes: {
        list: { component: 'riccardo-age-check-list', path: 'list' },
    },

    navigation: [{
        id: 'riccardo-age-check',
        label: 'Altersprüfungen',
        color: '#E30613',
        path: 'riccardo.age.check.list',
        icon: 'regular-shield',
        parent: 'sw-customer',
        position: 60,
    }],
});
